import RideList from './RideList';

export default RideList;



// WEBPACK FOOTER //
// ./src/ondemand/components/RideList/index.js